export default __webpack_public_path__ + "static/topper-4b249d57b41ef7e2c9e0cc7144b7561b.png";